// extracted by mini-css-extract-plugin
export default {"header":"Pt","fullPage":"Qt","closed":"Rt","minimize":"St","redcircle":"Tt","container":"Ut","text":"Vt","centered":"Wt","escapex":"Xt"};
    if(module.hot) {
      // 1737143654320
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  